import { render, staticRenderFns } from "./NathanModal.vue?vue&type=template&id=281ec49c&scoped=true&"
import script from "./NathanModal.vue?vue&type=script&lang=ts&"
export * from "./NathanModal.vue?vue&type=script&lang=ts&"
import style0 from "./NathanModal.vue?vue&type=style&index=0&id=281ec49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281ec49c",
  null
  
)

export default component.exports